import React , {useState} from "react";
import { Input } from "@chakra-ui/react";
import { useSearchParams } from "react-router-dom";

const GenericCustomSearch = ({ setExternalSearch }) => {
  const [searchParams, setSearchParams] = useSearchParams();
  const [searchValue, setSearchValue] = useState(searchParams.get("searchFilter") || "");

  return (
    <Input
      value={searchValue}
      placeholder="Search filter"
      onChange={(e) => {
        if (e.target.value === "") {
          setExternalSearch(null);
          setSearchValue("");
        } else {
          setExternalSearch(e.target.value);
          setSearchValue(e.target.value);
        }
      }}
    />
  );
};

//
export default GenericCustomSearch;
